import React, { useEffect, useMemo } from 'react';
import styles from './HeaderPreview.module.scss';
import PreviewSwitcher from '../PreviewSwitcher/PreviewSwitcher';
import { ReactComponent as FileFromDocument } from '../../../../resource/FileFromDocument.svg';
import { Icon, Spin } from 'antd';
import useAttachedFileQuery from '../../queries/useAttachedFileQuery';

const HeaderPreview = ({ filesOrder, onChangeFilesOrder, files }) => {
  const hasOneFile = files.length === 1;

  const currentFile = files[filesOrder];

  const { data, isFetching } = useAttachedFileQuery(
    {
      docId: currentFile?.docId,
      fileName: currentFile?.fileName,
    },
    {
      enabled: !!currentFile?.id && !currentFile?.originFileObj,
      staleTime: Infinity,
    }
  );

  const { blob } = useMemo(() => {
    if (!currentFile && !data) return {};

    if (currentFile?.originFileObj) {
      return {
        blob: currentFile.originFileObj,
        fileType: currentFile.originFileObj.type,
        fileName: currentFile.originFileObj.name,
      };
    }

    if (data) {
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(null)
        .map((_, i) => byteCharacters.charCodeAt(i));

      const byteArray = new Uint8Array(byteNumbers);

      const type = currentFile.mimeType || 'application/octet-stream';

      return {
        blob: new Blob([byteArray], { type }),
        fileType: type,
        fileName: currentFile.fileName,
      };
    }

    return {};
  }, [currentFile, data]);

  const url = useMemo(() => {
    if (!blob) return null;
    return URL.createObjectURL(blob);
  }, [blob]);

  useEffect(() => {
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [url]);

  return (
    <div className={styles.root}>
      {isFetching ? (
        <Spin
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        />
      ) : !currentFile || !blob ? (
        <div className={styles.errorText}>
          При загрузке файла произошла ошибка
        </div>
      ) : (
        <>
          <div className={styles.content}>
            <div className={styles.iconBlock}>
              <FileFromDocument style={{ color: '#3378F9' }} />
            </div>
            <div className={styles.name}>{currentFile?.name}</div>
            <a
              href={url}
              download={currentFile?.name}
              className={styles.downloadFile}
            >
              <Icon type="download" />
            </a>
          </div>
          {!hasOneFile && (
            <PreviewSwitcher
              filesOrder={filesOrder}
              onClick={onChangeFilesOrder}
              files={files}
            />
          )}
        </>
      )}
    </div>
  );
};

export default HeaderPreview;
